var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookingPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8031_1890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49967 0.707031C4.19655 0.707031 0.708008 4.19557 0.708008 8.4987C0.708008 12.8018 4.19655 16.2904 8.49967 16.2904C12.8028 16.2904 16.2913 12.8018 16.2913 8.4987C16.2913 4.19557 12.8028 0.707031 8.49967 0.707031ZM11.877 7.1812C11.9392 7.11011 11.9865 7.0273 12.0163 6.93765C12.046 6.848 12.0575 6.7533 12.05 6.65915C12.0426 6.56499 12.0164 6.47326 11.973 6.38937C11.9296 6.30548 11.8699 6.23111 11.7974 6.17065C11.7248 6.11018 11.6409 6.06484 11.5505 6.03728C11.4602 6.00973 11.3653 6.00052 11.2713 6.0102C11.1773 6.01988 11.0863 6.04825 11.0035 6.09365C10.9206 6.13904 10.8477 6.20054 10.789 6.27453L7.74317 9.92882L6.16713 8.35207C6.03354 8.22304 5.85461 8.15165 5.66889 8.15326C5.48317 8.15488 5.30551 8.22937 5.17418 8.3607C5.04285 8.49203 4.96835 8.66969 4.96674 8.85541C4.96512 9.04114 5.03652 9.22006 5.16555 9.35366L7.29055 11.4787C7.36015 11.5482 7.44347 11.6025 7.53522 11.6381C7.62696 11.6736 7.72511 11.6897 7.82341 11.6852C7.9217 11.6808 8.01799 11.6559 8.10613 11.6121C8.19427 11.5684 8.27233 11.5068 8.33534 11.4312L11.877 7.1812Z",
    fill: "#FF8383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8031_1890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookingPaid);
export default __webpack_public_path__ + "static/media/IconBookingPaid.8ccd1d54dd9d13d119030313a8e63ffb.svg";
export { ForwardRef as ReactComponent };